module.exports = __webpack_public_path__ + "static/img/Jai-Arrow.cdf63b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jai-Arrow.jpg
// module id = tHWn
// module chunks = 0